import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { DetectorListType } from "../../app/types/genericTables.types";

type UseDetectorType = {
  detectorsList: DetectorListType[];
  get: (id: DetectorListType["id"]) => DetectorListType | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useDetector = create<UseDetectorType>((set, get) => ({
  loading: false,
  detectorsList: [],
  query: "",
  setQuery: (query) => set({ query }),
  get: (id) => get().detectorsList.find((detector) => detector.id === id),
  fetchAll: async () => {
    set({ loading: true });
    try {
      const endpoint = "/generic/Detector";
      const { data: response } = await getData(endpoint);
      set(() => ({
        detectorsList: response,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching useDetector:", error);
      set({ loading: false });
    }
  },
}));
